<template>
  <div class="color-picker-container">
    <div class="picker-box">
      <div class="picker" />
      <div class="open-btn-box">
        <i class="el-icon-caret-bottom" @click="showPicker" />
      </div>
    </div>
    <div class="picker-type-box">
      <div class="picker-type-select-box">
        <el-select
          class="primary-select"
          size="small"
          v-model="pickerType"
          @change="handlePickerTypeChange"
          :popper-append-to-body="false"
        >
          <el-option
            v-for="item in pickerTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="picker-value-input-box">
        <el-input
          size="small"
          class="input-primary"
          v-model="pickerValue"
          @change="handlePickerValueChange"
        />
      </div>
    </div>
    <div class="recent-color-box" v-if="recentColorList.length">
      <div class="title">最近使用颜色</div>
      <div class="color-box">
        <div
          class="item-box"
          v-for="(item, index) in recentColorList"
          :key="index"
          :style="`background-color: ${item}`"
          @click="handleColorClick(item)"
        />
      </div>
    </div>
    <div class="recommend-color-box" v-if="recommendColorList.length">
      <div class="title">系统推荐颜色</div>
      <div class="color-box">
        <div
          class="item-box"
          v-for="(item, index) in recommendColorList"
          :key="index"
          :style="`background-color: ${item}`"
          @click="handleColorClick(item)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import "@simonwep/pickr/dist/themes/nano.min.css";
import Pickr from "@simonwep/pickr";

export default {
  data() {
    return {
      colorPicker: null,

      pickerType: "Hex",
      pickerTypeList: [
        { label: "Hex", value: "Hex" },
        { label: "RGB", value: "RGB" },
      ],

      pickerValue: "",
    };
  },
  props: {
    defaultColor: String,
    recentColorList: Array,
    recommendColorList: Array,
    onColorChange: Function,
  },
  watch: {
    defaultColor: function (newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.pickerValue = newVal;
          this.colorPicker.setColor(newVal);
        });
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initColorPicker();
    });
  },
  beforeDestroy() {
    this.colorPicker.off("change", this.onColorPickerChange);
    this.colorPicker.off("show", this.createCustomDom);

    this.destroyColorPicker();
  },
  methods: {
    initColorPicker() {
      this.colorPicker = Pickr.create({
        el: ".picker",
        theme: "nano",
        default: this.defaultColor ? this.defaultColor : "#1A55D1",
        appClass: "common-color-picker",
        position: "bottom-start",

        components: {
          preview: true,
          opacity: false,
          hue: true,
        },
      });

      this.colorPicker.on("change", this.onColorPickerChange);
      this.colorPicker.on("show", this.createCustomDom);
    },
    showPicker() {
      this.colorPicker.show();
    },
    destroyColorPicker() {
      this.colorPicker.destroyAndRemove();
      this.colorPicker = null;
    },
    createCustomDom() {
      let pickerRootDom = document.querySelector(".pcr-app");
      if (!pickerRootDom.querySelector(".picker-type-box")) {
        let pickerTypeDom = document.querySelector(".picker-type-box");
        pickerTypeDom.style.display = "flex";
        pickerRootDom.appendChild(pickerTypeDom);
      }

      if (!pickerRootDom.querySelector(".recent-color-box")) {
        let recentColorDom = document.querySelector(".recent-color-box");
        if (recentColorDom) {
          recentColorDom.style.display = "block";
          pickerRootDom.appendChild(recentColorDom);
        }
      }

      if (!pickerRootDom.querySelector(".recommend-color-box")) {
        let recommendColorDom = document.querySelector(".recommend-color-box");
        recommendColorDom.style.display = "block";
        pickerRootDom.appendChild(recommendColorDom);
      }
    },
    handlePickerTypeChange(value) {
      let color = this.colorPicker.getColor();
      switch (value) {
        case "Hex":
          this.pickerValue = color.toHEXA().toString();
          break;
        case "RGB":
          this.pickerValue = color.toRGBA().toString(0);
          break;
      }
    },
    handlePickerValueChange(value) {
      this.colorPicker.setColor(value);
    },
    handleColorClick(color) {
      this.colorPicker.setColor(color);
    },
    onColorPickerChange(hsvaObject) {
      let pickerType = this.pickerType;
      switch (pickerType) {
        case "Hex":
          this.pickerValue = hsvaObject.toHEXA().toString();
          break;
        case "RGB":
          this.pickerValue = hsvaObject.toRGBA().toString();
          break;
      }

      this.colorPicker.setColor(this.pickerValue);

      if (this.onColorChange) {
        this.onColorChange();
      }
    },
    getColor() {
      let color = this.colorPicker.getColor();
      let rgbaColor = color.toRGBA();
      let red = Number(rgbaColor[0].toFixed());
      let green = Number(rgbaColor[1].toFixed());
      let blue = Number(rgbaColor[2].toFixed());
      let colorArray = [red, green, blue];
      return colorArray;
    },
    getHexColor() {
      let color = this.colorPicker.getColor();
      return color.toHEXA().toString();
    },
  },
};
</script>

<style lang="less" scoped>
.picker-box {
  display: flex;
  align-items: center;

  .open-btn-box {
    width: 16px;
    height: 16px;
    cursor: pointer;
    text-align: center;
    // background: #646464;
  }

  /deep/ .pcr-button {
    display: flex;
    margin: auto;
    padding: 0px;

    &:focus {
      box-shadow: none;
    }
  }
}

.picker-type-box {
  display: none;
}

.recent-color-box {
  display: none;
  margin-top: 10px;

  .title {
    font-size: 14px;
    color: var(--default-color);
    opacity: 0.6;
  }

  .color-box {
    display: grid;
    grid-template-columns: repeat(auto-fill, 20px);
    gap: 10px;
    margin-top: 5px;

    .item-box {
      width: 20px;
      height: 20px;
      border-radius: 3px;
      cursor: pointer;
    }
  }
}

.recommend-color-box {
  display: none;
  margin-top: 10px;

  .title {
    font-size: 14px;
    color: var(--default-color);
    opacity: 0.6;
  }

  .color-box {
    display: grid;
    grid-auto-flow: column;
    gap: 10px;
    margin-top: 5px;

    .item-box {
      width: 20px;
      height: 20px;
      border-radius: 3px;
      cursor: pointer;
    }
  }
}
</style>